import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { HawkinsProvider } from '@hawkins/components';
import { HawkinsJSSProvider } from '@hawkins/styles';
import { FeatureFlagProvider } from './domains/shared/hooks/useFeatureFlag/FeatureFlagContext';
import { AppRoutes } from './routes';
import { NfaLogger } from './components/NfaLogger';

// Import Hawkins and grid styles
import '@inovua/reactdatagrid-enterprise/base.css';
import '@hawkins/table/lib/css/hawkins-dark.css';
import '@hawkins/components/lib/css/allHawkinsStyles.css';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <HawkinsProvider theme="dark">
          <HawkinsJSSProvider>
            <FeatureFlagProvider>
              <NfaLogger />
              <AppRoutes />
            </FeatureFlagProvider>
          </HawkinsJSSProvider>
        </HawkinsProvider>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
